import DynamicImage from '@/components/commons/dynamic-image';
import { ImagePopupmakerType } from '@/components/sections/builder/elements/body/popup-maker/type';
import ImageSetting from '@/components/sections/builder/settings/image-setting';
import { ElementProps } from '@/components/sections/builder/types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import useMediaQuery from '@/hooks/useMediaQuery';
import { cn } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import { Images } from 'lucide-react';
import { shallow } from 'zustand/shallow';

type ObjectFit = 'cover' | 'contain' | 'fill';

const IMAGE_OBJECT_FIT = [
  {
    value: 'cover',
    label: 'Cover',
  },
  {
    value: 'contain',
    label: 'Contain',
  },
  {
    value: 'fill',
    label: 'Fill',
  },
];

const defaultData: ImagePopupmakerType = {
  name: 'Image',
  image: 'https://placehold.co/300x400?text=Banner+Popup+Maker',
  objectFit: 'cover',
};

const ElementContent = ({ element }: ElementProps) => {
  const data = element.data as ImagePopupmakerType;
  const isMobile = useMediaQuery(768);

  return (
    <div className={cn('h-full w-full overflow-hidden', isMobile && 'flex-shrink-0')}>
      <DynamicImage
        width={100}
        height={100}
        src={(data.image ?? defaultData.image) as string}
        alt={`${data.name || 'Image'} banner`}
        sizes='100vw'
        className='h-full w-full'
        style={{
          objectFit: (data.objectFit || defaultData.objectFit) as ObjectFit,
        }}
      />
    </div>
  );
};

const ElementSetting = ({ element }: ElementProps) => {
  const data = element.data as ImagePopupmakerType;

  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  return (
    <div>
      <div className='flex flex-col gap-2'>
        <h4>Image Banner</h4>
        <ImageSetting
          value={data?.image}
          onChange={(val) =>
            builder.setChildData(element.parentId as string, element?.id as string, {
              image: val,
            })
          }
        />
      </div>
      <div className='flex flex-col gap-2'>
        <h4>Object fit</h4>
        <Select
          name='objectFit'
          defaultValue='cover'
          value={data.objectFit}
          onValueChange={(val) =>
            builder.setChildData(element.parentId as string, element.id, {
              objectFit: val,
            })
          }
        >
          <SelectTrigger className='py-5'>
            <SelectValue placeholder='Select' />
          </SelectTrigger>
          <SelectContent>
            {IMAGE_OBJECT_FIT.map((obj) => (
              <SelectItem key={obj.value} value={obj.value}>
                {obj.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
const ElementPreviewIcon = Images;

const ImagePopupmaker = {
  type: 'images',
  group: 'popup_maker',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
  maxEntries: 1,
};

export default ImagePopupmaker;
